//F18252/F18349 -> SMS OTP Delivery channel, custom GTM properties
export const OTP_CHANNEL_EMAIL = 'Email'; //Default
export const OTP_CUSTOM_EVENT_NAME = 'OTP response';
export const OTP_EVENT_NAME = 'OTP delivered';
export const OTP_RESPONSE_EVENT_NAME = 'OTP Response';
export const OTP_SUCCESS_VALIDATION_CHANNEL = 'x-via-hint_vch';
export const SRCI_NAME = 'VISA';

export const VSRCI_OTP_CHANNELS = {
  EMAIL: OTP_CHANNEL_EMAIL,
  EMAIL_SMS: 'Email-SMS',
  SMS: 'SMS'
};

export const VSRCI_OTP_EVENTS = {
  event: OTP_EVENT_NAME,
  event_action: OTP_EVENT_NAME,
  event_category: 'OTP Authentication',
  experience_owner: 'SRCi',
  otp_delivery_channel: OTP_CHANNEL_EMAIL,
  otp_provider: '',
  srci_name: SRCI_NAME
};

export const VSRCI_OTP_RESPONSE_EVENTS = {
  event: OTP_CUSTOM_EVENT_NAME,
  event_action: OTP_RESPONSE_EVENT_NAME,
  otp_delivery_channel: OTP_CHANNEL_EMAIL,
  otp_provider: '',
  srci_name: SRCI_NAME
};
